import { render, staticRenderFns } from "./fireFightingTraningEduYearDetail.vue?vue&type=template&id=42dce9ac"
import script from "./fireFightingTraningEduYearDetail.vue?vue&type=script&lang=js"
export * from "./fireFightingTraningEduYearDetail.vue?vue&type=script&lang=js"
import style0 from "./fireFightingTraningEduYearDetail.vue?vue&type=style&index=0&id=42dce9ac&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42dce9ac')) {
      api.createRecord('42dce9ac', component.options)
    } else {
      api.reload('42dce9ac', component.options)
    }
    module.hot.accept("./fireFightingTraningEduYearDetail.vue?vue&type=template&id=42dce9ac", function () {
      api.rerender('42dce9ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/fte/fireFightingTraningEduYearDetail.vue"
export default component.exports